import React, { useState } from 'react';
import parse from 'html-react-parser';

import styles from './tooltip.styles';

export default function Tooltip({ children, title, description, width, height, className, showOnClick, style }:
    { children: any, title?: string, description?: string, width?: number, height?: number, className?: string, showOnClick?: boolean, style?: any }) {
    const [active, setActive] = useState(false);
    return (
        <div className={styles.tooltip(width, height) + ` ${className} ${showOnClick ? (active ? 'active' : 'inactive') : ''}`}
             onClick={() => showOnClick ? setActive(!active) : {}} style={style}
        >
            {children}
            {(title || description) &&
                <div className={'ing-tooltip'}>
                    {title &&
                        <p className="title mb-0">{title}</p>
                    }
                    {description &&
                        <p className="sub mb-0">{parse(description)}</p>
                    }
                </div>
            }
        </div>
    );
}